import { twMerge } from 'tailwind-merge';
import { AscendingIcon, DescendingIcon } from '@/icons';
import {
  default as MuiTableCell,
  type TableCellProps as MuiTableCellProps,
} from '@mui/material/TableCell';
import { SORT_ORDER } from '@flemingmetrics/api-client';
import { classes } from './utils';

export interface SortableHeadCellProps extends MuiTableCellProps {
  className?: string;
  sortOrder: null | keyof typeof SORT_ORDER;
  onSort: () => void;
}

export default function SortableHeadCell({
  className = '',
  sortOrder,
  onSort,
  children,
}: SortableHeadCellProps) {
  const renderArrow = () => {
    return sortOrder === SORT_ORDER.DESCENDING ? (
      <DescendingIcon className={classes.arrow} size={20} />
    ) : (
      <AscendingIcon className={classes.arrow} size={20} />
    );
  };

  return (
    <MuiTableCell
      className={twMerge(classes.cell, className)}
      onClick={() => onSort()}>
      <div className={classes.content}>
        <label className={classes.label}>{children}</label>
        {sortOrder !== null && renderArrow()}
      </div>
    </MuiTableCell>
  );
}
